import { GenericTableColumn } from 'shared/components/thunderbolt/IWGenericTable'

export const lsAdminConfigsTableSchema = [
  {
    title: 'Market',
    accessor: 'market',
    align: 'left',
    sortable: true,
    filterType: 'string',
    disableToggle: true,
  },
  {
    title: 'Brand',
    accessor: 'brand',
    align: 'left',
    sortable: true,
    filterType: 'string',
    disableToggle: true,
  },
  {
    title: 'Enable',
    accessor: 'enabled',
    align: 'center',
    disableToggle: true,
  },
  {
    title: 'Actions',
    accessor: 'contextMenu',
    align: 'center',
    disableToggle: true,
  },
] as GenericTableColumn[]

export const lsAdminCredentialsTableSchema = [
  {
    title: 'Market',
    accessor: 'market',
    align: 'left',
    sortable: true,
    disableToggle: true,
    filterType: 'string',
  },
  {
    title: 'Brand',
    accessor: 'brand',
    align: 'left',
    minWidth: 150,
    sortable: true,
    disableToggle: true,
    filterType: 'string',
  },
  {
    title: 'Zone',
    accessor: 'zone',
    align: 'left',
    sortable: true,
    disableToggle: true,
    filterType: 'string',
  },
  {
    title: 'Location Name',
    accessor: 'locationName',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Location',
    accessor: 'location',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'User ID',
    accessor: 'userId',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'User Account',
    accessor: 'userAccount',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Sub-account',
    accessor: 'userSubAccount',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Is SUMA',
    accessor: 'isSuma',
    align: 'left',
  },
  {
    title: 'Config Status',
    accessor: 'isConfigActive',
    align: 'center',
    disableToggle: true,
  },
  {
    title: 'Enable',
    accessor: 'enabled',
    align: 'center',
    disableToggle: true,
  },
  {
    title: 'Actions',
    accessor: 'contextMenu',
    align: 'center',
    disableToggle: true,
  },
] as GenericTableColumn[]

export const lsAdminLocationAttributesTableSchema = [
  {
    title: 'Market',
    accessor: 'market',
    align: 'left',
    sortable: true,
    filterType: 'string',
    disableToggle: true,
  },
  {
    title: 'Brand',
    accessor: 'brand',
    align: 'left',
    sortable: true,
    filterType: 'string',
    disableToggle: true,
  },
  {
    title: 'Zone',
    accessor: 'zone',
    align: 'left',
    sortable: true,
    filterType: 'string',
    disableToggle: true,
  },
  {
    title: 'Utility',
    accessor: 'utility',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Location Name',
    accessor: 'locationName',
    align: 'left',
    minWidth: 150,
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Location',
    accessor: 'location',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Config Status',
    accessor: 'isConfigActive',
    align: 'center',
    disableToggle: true,
  },
  {
    title: 'Credential Status',
    accessor: 'status',
    align: 'center',
    disableToggle: true,
  },
  {
    title: 'Actions',
    accessor: 'contextMenu',
    align: 'center',
    disableToggle: true,
  },
] as GenericTableColumn[]

export const lsAdminCertificateInformationTableSchema = [
  {
    title: 'Market',
    accessor: 'market',
    align: 'left',
    sortable: true,
    filterType: 'string',
    disableToggle: true,
  },
  {
    title: 'Brand',
    accessor: 'brand',
    align: 'left',
    sortable: true,
    filterType: 'string',
    disableToggle: true,
  },
  {
    title: 'Zone',
    accessor: 'zone',
    align: 'left',
    sortable: true,
    filterType: 'string',
    disableToggle: true,
  },
  {
    title: 'Location Name',
    accessor: 'locationName',
    sortable: true,
    align: 'left',
    minWidth: 150,
    filterType: 'string',
  },
  {
    title: 'Location',
    accessor: 'location',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Expiration Date',
    accessor: 'notAfter',
    align: 'left',
    minWidth: 275,
    sortable: true,
    filterType: 'datetime',
  },
  {
    title: 'Status',
    accessor: 'expired',
    align: 'center',
    pinnable: true,
    sticky: 'right',
    disableToggle: true,
  },
] as GenericTableColumn[]

export const lsAdminIBTContractsTableSchema = [
  {
    title: 'Market',
    accessor: 'market',
    align: 'left',
    sortable: true,
    filterType: 'string',
    disableToggle: true,
  },
  {
    title: 'Brand',
    accessor: 'brand',
    align: 'left',
    sortable: true,
    filterType: 'string',
    disableToggle: true,
  },
  {
    title: 'Zone',
    accessor: 'zone',
    align: 'left',
    sortable: true,
    filterType: 'string',
    disableToggle: true,
  },
  {
    title: 'Contract Name',
    accessor: 'contractName',
    align: 'left',
    sortable: true,
    filterType: 'string',
    minWidth: 300,
    disableToggle: true,
  },
  {
    title: 'Contract ID',
    accessor: 'contractId',
    align: 'left',
    sortable: true,
    filterType: 'string',
    minWidth: 200,
  },
  {
    title: 'Location Name',
    accessor: 'locationName',
    sortable: true,
    align: 'left',
    minWidth: 150,
    filterType: 'string',
  },
  {
    title: 'Location',
    accessor: 'location',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Buy or Sell',
    accessor: 'buyOrSell',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Buyer',
    accessor: 'buyerName',
    align: 'left',
    minWidth: 250,
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Buyer QSE Code',
    accessor: 'buyerQseCode',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Seller',
    accessor: 'sellerName',
    align: 'left',
    sortable: true,
    minWidth: 250,
    filterType: 'string',
  },
  {
    title: 'Seller QSE Code',
    accessor: 'sellerQseCode',
    align: 'left',
    sortable: true,
    filterType: 'string',
  },
  {
    title: 'Counterparty',
    accessor: 'counterparty',
    align: 'left',
    sortable: true,
    filterType: 'string',
    minWidth: 250,
  },
  {
    title: 'Config Status',
    accessor: 'isConfigActive',
    align: 'center',
    disableToggle: true,
  },
  {
    title: 'Credential Status',
    accessor: 'status',
    align: 'center',
    disableToggle: true,
  },
  {
    title: 'Actions',
    accessor: 'contextMenu',
    align: 'center',
    disableToggle: true,
  },
] as GenericTableColumn[]
